import { EpimsBaseEntityDto } from './epim-base.dto';

export class RequestSubCategoryDto extends EpimsBaseEntityDto{
  RequestSubCategoryName: string;
  RequestCategoryId: string;
  SiteId: string;
  ModifiedById: string;
  CreatedById: string;
  dateUpdated: Date;
  dateCreated: Date;
  Version: Number;
  SubscriberId: string;

  }